import React, { useState, useEffect, useContext } from 'react';
import isEmpty from 'lodash/isEmpty';
import Messaging from 'components/Messaging/Messaging';
import { AuthContext } from 'context/AuthProvider';
import messagesService from 'services/messagesService.js';
import { dateSortDesc } from 'library/helpers/utils';

const MESSAGE_UPDATES_TIME_FORMAT = 'MMM DD, HH:mm:ss';

const Messages = ({ marina }) => {
  const { updates } = useContext(AuthContext);
  const messageUpdate = updates.message
    ? updates.message.format(MESSAGE_UPDATES_TIME_FORMAT)
    : null;
  const { marina_settings } = marina;
  const { permissions } = marina_settings;

  const [messages, setMessages] = useState([]);
  const [read, setRead] = useState([]);
  const [unread, setUnread] = useState([]);

  useEffect(() => {
    const getMarinaMessages = async () => {
      if (!isEmpty(marina)) {
        try {
          const res = await messagesService.getAllMarina(marina.id);
          const sortedReadMessages = res
            .filter(
              mes =>
                mes.sender === 'BOATER' ||
                (mes.receiver === 'BOATER' && !!mes.read_by_receiver === true)
            )
            .sort(dateSortDesc);
          const sortedUnreadMessages = res
            .filter(
              mes =>
                mes.receiver === 'BOATER' && !!mes.read_by_receiver === false
            )
            .sort(dateSortDesc);
          setMessages(res.sort(dateSortDesc));
          setRead(sortedReadMessages);
          setUnread(sortedUnreadMessages);
        } catch (err) {
          console.error(err);
        }
      }
    };
    getMarinaMessages();
  }, [messageUpdate, marina]);

  useEffect(() => {
    return () => {
      readMessages();
    };
  }, [unread]);

  const readMessages = async () => {
    if (unread.length) {
      try {
        await messagesService.read({ message_ids: unread.map(({ id }) => id) });
      } catch (err) {
        console.error(err);
      }
    }
  };

  const sendMessage = async data => {
    try {
      await messagesService.create({ ...data, marina_id: marina.id });
      await readMessages();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Messaging
      isAllowed={Boolean(permissions && permissions.chat)}
      className='marina-messaging'
      messages={messages}
      unread={unread}
      read={read}
      sendMessage={sendMessage}
      marina={marina}
    />
  );
};

export default Messages;
